<template>
  <!-- 选择询价商品 -->
  <e-dialog
    dialog-title="商品清单"
    :center-dialog-visible="goodsVisible"
    popup-width="1000px"
    append-to-body
    @resetPopupData="closeGoodsDialog"
    @submitPopupData="addSkuBatch"
  >
    <div class="list-box">
      <el-table
        ref="table"
        v-loading="tableLoading"
        v-loadMore.expand="{
          func: load,
          distance: 10,
          target: '.el-table__body-wrapper',
          delay: 300,
        }"
        max-height="300"
        :data="tableData"
        border
        size="small"
        style="width: 100%"
        :load-more-disabled="disabled"
        :header-cell-style="{ background: '#F5F5F5' }"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" fixed="left"></el-table-column>
        <el-table-column
          v-for="item in tableLabel"
          :key="item.param"
          :prop="item.param"
          :label="item.label"
          min-width="120"
          :align="item.align || 'center'"
        ></el-table-column>
      </el-table>
      <p class="show-total">共计{{ total }}个商品</p>
    </div>
  </e-dialog>
</template>

<script>
import tableList from '@/modules/projectA/components/common/e-table-list.vue';
import EDialog from '@/modules/projectA/components/common/e-dialog.vue';
import Api from '@/modules/projectA/api/product';

export default {
  components: { EDialog, tableList },
  props: {
    goodsVisible: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      tableLoading: false,
      total: 0,
      totalPages: 0,
      tableData: [],
      tableLabel: [
        { label: '单品编号', param: 'skucode', align: 'center' },
        { label: '商品名称', param: 'skuname', align: 'center' },
        { label: '类目名称', param: 'category', align: 'center' },
        { label: '计量单位', param: 'unitvalue', align: 'center' },
        { label: '品牌', param: 'brandname', align: 'center' },
        { label: '供应商名称', param: 'suppliercompanyname', align: 'center' },
        { label: '平台价（元）', param: 'price', align: 'center' },
      ],
      listQuery: {
        pageNum: 0,
        pageSize: 10,
      },
      selectedGoods: [],
    };
  },
  computed: {
    noMore() {
      return this.listQuery.pageNum >= this.totalPages;
    },
    disabled() {
      return this.tableLoading || this.noMore;
    },
  },
  mounted() {
    this.listQuery = { ...this.listQuery, ...this.params };
    this.load();
  },
  methods: {
    load() {
      this.listQuery.pageNum++;
      this.getList(this.listQuery);
    },
    async getList(params) {
      this.tableLoading = true;
      const result = await Api.getProductBySupplierCompanyId(params);
      if (result.code === '200') {
        this.tableData = this.tableData.concat(result.data?.list);
        this.total = result.data.total;
        this.totalPages = Math.ceil(result.data.total / result.data.pageSize);
        this.tableLoading = false;
      }
    },

    handleSelectionChange(selectVal) {
      this.selectedGoods = [...selectVal];
    },
    async addSkuBatch() {
      if (this.selectedGoods.length === 0) {
        this.$message.warning('请选择商品');
        return;
      }
      this.$emit('onChoose', this.selectedGoods);
      this.closeGoodsDialog();
    },

    closeGoodsDialog() {
      this.$refs.table.clearSelection();
      this.listQuery = { ...this.cloneSelectProductsForm };
      this.$emit('update:goodsVisible', false);
    },
  },
};
</script>
<style lang="scss" scoped>
.show-total {
  margin-top: 10px;
  font-size: 12px;
  color: #f0250f;
}

// 列表重置样式-开始
::v-deep .el-table__header .cell {
  .icon-question {
    height: 18px;
    width: 18px;
    line-height: 18px;
    text-align: center;
    border-radius: 50%;
    border: 1px solid #c5c5c5;
    color: #c5c5c5;
    display: inline-block;
    margin-left: 10px;

    &:hover {
      color: #fff;
      background-color: #c5c5c5;
    }
  }
}

::v-deep .el-table__row .cell {
  font-size: 12px;
  white-space: normal;
  padding-left: 6px;
  padding-right: 6px;

  .el-button {
    font-size: 12px;
  }

  .el-input__inner {
    padding: 0 6px;
  }

  .edit-info {
    color: #c0c4cc;
  }
}

::v-deep .el-table--small td,
::v-deep .el-table--small th {
  padding: 6px 0;
}

::v-deep .el-table--small .el-table-column--selection {
  .cell {
    padding-left: 10px;
    padding-right: 10px;

    .el-checkbox__inner {
      border-radius: 0;
    }
  }
}

// 列表重置样式-结束

// dialog 重置样式开始
::v-deep .el-dialog__header {
  background: #f5f5f5;
  height: 40px;
  padding: 0 20px;
  line-height: 40px;

  .el-dialog__headerbtn {
    top: 8px;
  }

  .el-dialog__title {
    font-size: 14px;
  }
}

// dialog 重置样式结束

.audit-record {
  .search-form {
    ::v-deep .el-input__inner {
      border-radius: 0;
    }
  }

  .search-box {
    background: #fff;

    ::v-deep {
      .el-form-item__content {
        width: 200px;
      }
    }

    ::v-deep .el-form-item--small.el-form-item {
      margin-bottom: 10px;
      margin-right: 20px;
    }

    .search-btn {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-bottom: 16px;

      .btn {
        width: 80px;
        text-align: center;
        height: 30px;
        line-height: 27px;
        cursor: pointer;
        padding: 0;
        margin-right: 10px;
      }

      /* .reset-btn {
        background: #e8efff;
        border: 1px solid #2587ff;
        color: #2587ff;
        margin-right: 30px;
        line-height: 27px;
        &:hover,
        :active {
          background-color: #126edf;
          color: #fff;
        }
      }
      .submit-btn {
        background: #2587ff;
        border: 1px solid #2587ff;
        color: #ffffff;
        &:hover,
        :active {
          background-color: #126edf;
        }
      } */
    }
  }

  .list-box {
    margin-top: 10px;
  }

  .pagination-box {
    text-align: right;
    margin-top: 20px;

    ::v-deep .el-pagination {
      button {
        height: 30px;
        color: #999;
      }

      .el-select {
        .el-input__inner {
          border-radius: 0;
          height: 30px;
        }
      }

      .el-input__inner {
        border-radius: 0;
        height: 30px;
        color: #999;
      }

      .el-select-dropdown__item,
      .el-pagination__jump,
      .el-pagination__total {
        color: #999;
        line-height: 30px;
      }

      .el-pager {
        li {
          border-radius: 0;
          border: 1px solid #d9d9d9;
          line-height: 28px;
          text-align: center;
          margin-left: 10px;
          width: 40px;
          height: 30px;
          color: #999;

          &:first-child {
            margin-left: 0;
          }

          &.active {
            background: #2587ff;
            border: none;
            color: #fff;
          }
        }
      }
    }
  }

  ::v-deep .el-dialog__body {
    padding: 10px;
  }

  ::v-deep .el-dialog__footer {
    display: flex;
    justify-content: center;

    .btn {
      width: 80px;
      text-align: center;
      height: 30px;
      line-height: 27px;
      cursor: pointer;
      border-radius: 0;
      padding: 0;
      margin-right: 10px;
    }

    .default-btn {
      background: #fff;
      border: 1px solid #dcdfe6;

      &:hover {
        border-color: #2587ff;
        color: #2587ff;
      }
    }
  }
}
</style>
